export class BoundingBox {
    constructor(
      public x: number,
      public y: number,
      public width: number,
      public height: number,
      public sourceWidth: number,
      public sourceHight: number,
    ) {}

    scaleTo(targetWidth: number, targetHeight: number): BoundingBox {
        const scaleX = targetWidth / this.sourceWidth;
        const scaleY = targetHeight / this.sourceHight;

        return new BoundingBox(
            this.x * scaleX,
            this.y * scaleY,
            this.width * scaleX,
            this.height * scaleY,
            targetWidth,
            targetHeight
        );
    }
  }